import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'p-checkbox-question',
  templateUrl: './checkbox-question.component.html',
  styleUrls: ['./checkbox-question.component.scss']
})

export class CheckboxQuestionComponent implements OnInit {

  @Output() onChangeValue = new EventEmitter<any>();

  @Input() label: string = '';
  @Input() disabled: string = '';
  @Input() required: boolean = true;
  @Input() checkedError: boolean = false;
  @Input() checkBoxes:any = []; 
  @Input() checked = false;
  checkedTrue:boolean=false;
  checkedFalse:boolean=true;


  constructor() { }

  ngOnInit(): void {
    if (this.checked) {
      this.checkedTrue = true;
      this.checkedFalse = false;
    }
    
  }  

  onChangeValueResp(resp: any, event: any){
    switch (resp) {
      case 'SI':
        this.onChangeValue.emit(event);
        this.checkedFalse=false;
        this.seeCheckedError();
        break;
      case 'NO':
        if (event.checked) this.checkedError=true;
        event.checked = false;
        this.onChangeValue.emit(event);
        this.checkedTrue=false;
        this.seeCheckedError();
    }    
  }

  seeCheckedError () {
    if (!this.checkedFalse && !this.checkedTrue) {
      this.checkedError=true;
    } else {
      this.checkedError=false;
    }
  }
}
